var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardDetailbrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7364 12.6666L17.7381 13.2677C17.9355 13.3861 17.9994 13.642 17.8811 13.8393C17.8458 13.898 17.7968 13.9471 17.7381 13.9822L10.429 18.3677C10.1651 18.5261 9.83539 18.5261 9.57156 18.3677L2.26241 13.9822C2.06509 13.8638 2.00111 13.6079 2.1195 13.4106C2.15469 13.3519 2.20376 13.3028 2.26241 13.2677L3.26416 12.6666L10.0003 16.7082L16.7364 12.6666ZM16.7364 8.7499L17.7381 9.35099C17.9355 9.46941 17.9994 9.72532 17.8811 9.92265C17.8458 9.98132 17.7968 10.0304 17.7381 10.0656L10.0003 14.7082L2.26241 10.0656C2.06509 9.94715 2.00111 9.69124 2.1195 9.49391C2.15469 9.43524 2.20376 9.38616 2.26241 9.35099L3.26416 8.7499L10.0003 12.7916L16.7364 8.7499ZM10.429 1.09052L17.7381 5.47599C17.9355 5.59438 17.9994 5.85032 17.8811 6.04765C17.8458 6.1063 17.7968 6.15538 17.7381 6.19056L10.0003 10.8332L2.26241 6.19056C2.06509 6.07217 2.00111 5.81623 2.1195 5.6189C2.15469 5.56025 2.20376 5.51118 2.26241 5.47599L9.57156 1.09052C9.83539 0.932188 10.1651 0.932188 10.429 1.09052ZM10.0003 2.77693L4.90635 5.83328L10.0003 8.88965L15.0942 5.83328L10.0003 2.77693Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardDetailbrand);
export default __webpack_public_path__ + "static/media/rewardDetailbrand.9b4f7a9b3bb58d864c1e56abeeeec9d7.svg";
export { ForwardRef as ReactComponent };